export default "__VITE_ASSET__CvHwXC5H__"